<template>
  <div>
    <v-dialog width="800" v-model="showchange">
      <template v-slot:activator="{ on }">
        <v-btn
          flat
          outline
          class="primary mr-2"
          :style="`line-height: 10px;color: ${$vuetify.theme.primary};`"
          v-on="on"
          v-if="!$store.state.isFacebook"
          >{{ $t('Change Password') }}</v-btn
        >
      </template>
      <v-card v-if="showchange">
        <v-container>
          <v-card-text>
            <h5>{{ $t('Change Password') }}</h5>
            <form class="form-control" :class="{ 'has-error': errors.has('password') }">
              <label>{{ $t('New password') }}</label>
              <input
                v-validate="'required'"
                name="password"
                type="password"
                :data-vv-as="$t('password')"
                v-model.trim="password"
                autocomplete="on"
                ref="password"
              />
              <span class="text-error" v-if="errors.has('password')">{{
                errors.first('password')
              }}</span>
            </form>
            <form class="form-control" :class="{ 'has-error': errors.has('passwordconfirm') }">
              <label>{{ $t('Confirm password') }}</label>
              <input
                v-validate="'required|confirmed:password'"
                name="passwordconfirm"
                :data-vv-as="$t('password')"
                type="password"
                autocomplete="on"
                v-model.trim="confirmpassword"
              />
              <span class="text-error" v-if="errors.has('passwordconfirm')">{{
                errors.first('passwordconfirm')
              }}</span>
            </form>
            <div class="text-xs-center">
              <v-btn @click="cancel" outline color="grey">{{ $t('cancel') }}</v-btn>
              <v-btn
                @click="onchangepassword"
                :loading="loading"
                :disabled="loading"
                depressed
                color="primary"
                >{{ $t('Save') }}</v-btn
              >
            </div>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

export default {
  props: ['userid', 'type'],
  data() {
    return {
      showchange: false,
      loading: false,
      password: '',
      confirmpassword: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot', 'isFacebook', 'currentLang'])
  },
  methods: {
    cancel() {
      //   this.password = ''
      //   this.confirmpassword = ''
      this.showchange = false
    },
    async onchangepassword() {
      var vm = this

      this.loading = true
      var result = await vm.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        return false
      }

      try {
        var response = await this.changepassword()
        if (response.responsecode === 200) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('Success')
          })
          if (this.$store.state.userid == this.userid) {
            this.$store.dispatch('logout', null).then()
            if (this.type == 'admin') {
              this.$router.push('/' + this.currentLang + '/nigol')
            } else {
              this.$router.push('/' + this.currentLang + '/login')
            }
          }
          this.showchange = false
        }
      } catch (error) {}
      this.loading = false
    },
    changepassword() {
      var data = {
        userid: this.userid,
        pageid: this.selectedBot.pageid,
        password: this.confirmpassword
      }
      return new Promise((resolve, reject) => {
        api.changeticketpasswordadminuser({ data: data }, (error, response) => {
          if (error) reject(error)
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/ChangePassword.vue